import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';



const routes: Routes = [

    {
        path: 'rewards',
        loadChildren: () => import('./components/rewards/manage-rewards.module').then(m => m.ManageRewardsModule),
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { })],
    exports: [RouterModule]
})
export class AppRoutingModule {
}

